import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

/**
 * Horloge Mali (Africa/Bamako = GMT+0) — format 24h HH:MM:SS
 * Compacte et non intrusive : semi-transparente avec backdrop-blur.
 */
export const MaliClock = ({ compact = false }) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const timeStr = now.toLocaleTimeString('fr-FR', {
    timeZone: 'Africa/Bamako',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  const dateStr = now.toLocaleDateString('fr-FR', {
    timeZone: 'Africa/Bamako',
    weekday: 'short',
    day: '2-digit',
    month: 'short',
  });

  if (compact) {
    return (
      <div
        className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-white/80 backdrop-blur-md border border-[#B85C38]/30 text-[#2B3A2C] shadow-sm"
        title={`${dateStr} · Heure du Mali (GMT)`}
        data-testid="mali-clock-compact"
      >
        <Clock className="w-3 h-3 text-[#B85C38]" />
        <span className="text-[11px] font-mono font-bold tabular-nums" data-testid="mali-clock-time">
          {timeStr}
        </span>
      </div>
    );
  }

  return (
    <div
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/80 backdrop-blur-md border border-[#B85C38]/25 shadow-sm hover:bg-white/95 hover:border-[#B85C38]/45 transition-all"
      title="Heure officielle du Mali (GMT)"
      data-testid="mali-clock"
    >
      <Clock className="w-3.5 h-3.5 text-[#B85C38]" />
      <div className="flex flex-col leading-none">
        <span className="text-[13px] font-mono font-bold tabular-nums text-[#2B3A2C]" data-testid="mali-clock-time">
          {timeStr}
        </span>
        <span className="text-[9px] text-[#857567] uppercase tracking-wide mt-0.5 font-semibold">
          {dateStr} · Mali
        </span>
      </div>
    </div>
  );
};

export default MaliClock;
